const APIs = {
  LOGIN: `api/Auth/LoginBackOffice`,
  AUTO_LOGIN: `/api/Auth/AutoLogin`,
  GET_USER_PROFILE: `/api/Staff/GetUserProfile`,
  GET_USER_SETTINGS: `/api/Setting/GetUserSettings`,

  //Company
  GET_COMPANY: `/api/Company/UpdatedCompanyData`,
  GET_COMPANY_PROFILE: `/api/Company/Profile`,
  PUT_UPDATE_COMPANY_DATA: `/api/Company/UpdateCompany`,
  POST_UPDATE_WEEKLY_SERVICE_HOURS: `/api/Company/UpdateCompanyServiceHours`,
  POST_UPDATE_COMPANY_LOGO: `/api/Company/UpdateCompanyLogo`,
  GET_COMPANY_SETTINGS: `/api/Setting/GetCompanySettings`,
  UPDATE_COMPANY_SETTINGS: `/api/Setting/UpdateCompanySettings`,
  POST_UPDATE_COMPANY_SETTING: `/api/Setting/UpdateCompanySettings`,
  REMOVE_COMPANY_LOGO: `/api/Company/RemoveCompanyLogo`,

  // Devices

  GET_ALL_DEVICES_OF_COMPANY: `/api/Device/BO_GetCompanyDevices`,
  GET_ALL_DEVICES: `/api/Device/GetCompanyDevices`,
  PATCH_UPDATE_DEVICE_STATUS: `/api/Till/UpdateCompanyStatus`,
  DELETE_COMPANY_DEVICE: `/api/Device/DeleteCompanyDevice`,

  // Payment Gateways

  GET_ALL_PAYMENT_GATEWAYS: `/api/PaymentGateway/BO_GetPaymentGateways`,
  POST_ADD_PAYMENT_GATEWAY: `/api/PaymentGateway/AddPaymentGateway`,
  UPDATE_PAYMENT_GATEWAY: `/api/PaymentGateway/UpdatePaymentGateway`,
  DELETE_PAYMENT_GATEWAY: `/api/PaymentGateway/DeletePaymentGateway`,

  //Petty Cash
  GET_PETTY_CASH_HEADS: `/api/PettyCash/BO_GetCashHeads`,
  POST_PETTY_CASH_HEAD: `/api/PettyCash/AddUpdatePettyCash`,
  PUT_UPDATE_PETTY_CASH_HEAD: `/api/PettyCash/AddUpdatePettyCash`,
  GET_PETTY_CASH_HEAD_BY_ID: `/api/PettyCash/GetCashHeadByID`,
  DELETE_PETTY_CASH_HEAD: `/api/PettyCash/DeletePettyCashByID`,
  UPDATE_PETTY_CASH_STATUS: `/api/PettyCash/UpdatePettyCashStatus`,

  // Staff
  GET_COMPANY_STAFF: `api/Staff/BO_GetCompanyStaff`,
  GET_ALL_STAFF: `/api/Staff/GetCompanyStaffList`,
  DELETE_COMPANY_STAFF: `api/Staff/DeleteStaff`,
  GET_STAFF_DATA: `/api/Staff/GetUserByUserName`,
  ADD_STAFF: `/api/Staff/AddUser`,
  UPDATE_STAFF: `/api/Staff/UpdateUser`,
  UPDATE_PASSWORD: `/api/Staff/UpdatePassword`,
  UPDATE_STAFF_IMAGE: `/api/Staff/UpdateStaffImage`,
  REMOVE_STAFF_IMAGE: `/api/Staff/RemoveStaffImage`,

  // Staff Time Tracking
  AUTO_CLOCK_OUT_EXPIRED_SHIFTS: `/api/StaffTimeTracking/AutoClockOutExpiredShifts`,


  // Staff Work Report
  GET_STAFF_WORK_REPORT: `/api/Report/GetStaffShiftReport`,
  GET_ALL_STAFF_WORK_REPORTS: `/api/Report/GetAllStaffShiftReports`,
  GET_STAFF_SALES_REPORT: `/api/Report/GetStaffWorkReport`,

  // Staff Payout
  GENERATE_PAYOUT: `/api/StaffPayout/GeneratePayout`,
  GET_PAYOUTS: `/api/StaffPayout/GetPayouts`,
  GET_UNPAID_HOURS: `/api/StaffPayout/GetUnpaidHours`,
  APPROVE_PAYOUT: `/api/StaffPayout/ApprovePayout`,
  PROCESS_PAYOUT: `/api/StaffPayout/ProcessPayout`,
  GET_PAYOUT_DETAILS: `/api/StaffPayout/GetPayoutDetails`,


  // Suppliers
  GET_ALL_SUPPLIERS: `/api/Supplier/BO_GetSupplierList`,
  GET_SUPPLIER_BY_ID: `/api/Supplier/GetSupplierByID`,
  POST_ADD_SUPPLIER: `/api/Supplier/AddSupplier`,
  PUT_UPDATE_SUPPLIER: `/api/Supplier/UpdateSupplier`,
  DELETE_SUPPLIER_BY_ID: `/api/Supplier/DeleteSupplierByID`,

  //Roles
  GET_ROLES: `/api/RolePermission/GetAllRoles`,
  GET_ROLE_BY_ID: `/api/RolePermission/GetRoleByID`,
  ADD_ROLE: `/api/RolePermission/AddNewRole`,
  UPDATE_ROLE: `/api/RolePermission/UpdateRolePermission`,
  DELETE_ROLE: `/api/RolePermission/DeleteRole`,

  //City

  GET_ALL_CITIES: `/api/City/GetAllCitiesListForCountryCode`,

  // Categories
  GET_CATEGORIES: `/api/RootCategories/BO_GetAllCategories`,
  GET_CATEGORY_ROOT_ID: `/api/RootCategories/GetRootCategoryByRootCatID`,
  ADD_CATEGORY: `/api/RootCategories/AddCategory`,
  UPDATE_CATEGORY: `/api/RootCategories/UpdateCategory`,
  POST_UPDATE_CATEGORY_SORT_ORDER: `/api/RootCategories/UpdateCategorySortOrder`,
  POST_UPDATE_CATEGORY_STATUS: `/api/RootCategories/UpdateCategoryStatus`,
  DELETE_ROOT_CATEGORY: `/api/RootCategories/DeleteCategory`,

  //Category Departments
  GET_ALL_CATEGORY_DEPARTMENTS: `/api/CategoryDepartments/BO_GetCompanyCategoryDepartments`,
  GET_CATEGORY_DEPARTMENT_BY_ID: `/api/CategoryDepartments/GetCategoryDepartmentByID`,
  POST_ADD_CATEGORY_DEPARTMENT: `/api/CategoryDepartments/InsertCategoryDepartment`,
  PUT_UPDATE_CATEGORY_DEPARTMENT: `/api/CategoryDepartments/UpdateCategoryDepartment`,
  DELETE_CATEGORY_DEPARTMENT: `/api/CategoryDepartments/DeleteCategoryDepartment`,
  POST_UPDATE_CATEGORY_DEPARTMENT_SORT_ORDER: `/api/CategoryDepartments/UpdateCategoryDepartmentSortOrder`,

  // Reporting Categories
  GET_ALL_REPORTING_CATEGORIES: `/api/ReportingCategory/GetAllReportingCategories`,
  GET_REPORTING_CATEGORY_BY_ID: `/api/ReportingCategory/GetReportingCategoryByID`,
  POST_ADD_REPORTING_CATEGORY: `/api/ReportingCategory/InsertReportingCategory`,
  PUT_UPDATE_REPORTING_CATEGORY: `/api/ReportingCategory/UpdateReportingCategory`,
  DELETE_REPORTING_CATEGORY: `/api/ReportingCategory/DeleteReportingCategory`,
  POST_UPDATE_REPORTING_CATEGORY_SORT_ORDER: `/api/ReportingCategory/UpdateReportingCategorySortOrder`,

  // Menus

  POST_ADD_MENU: `/api/Menu/AddMenu`,
  POST_ADD_MENU_GROUP_LIST: `/api/MenuGroup/AddMenuGroupList`,
  GET_MENU_LIST: `/api/Menu/BO_GetAllMenus`,
  GET_MENU_BY_MENU_ID: `/api/Menu/GetMenuByMenuID`,
  GET_All_MENU_GroupS: `/api/Menu/GetAllMenusWithTheirGroups`,
  DELETE_MENU: `/api/Menu/DeleteMenu`,
  PUT_UPDATE_MENU_AND_MENU_GROUP: `/api/Menu/UpdateMenu`,
  POST_UPDATE_MENU_SORT_ORDER: `/api/Menu/UpdateMenuSortOrder`,
  POST_UPDATE_MENU_STATUS: `/api/Menu/UpdateMenuStatus`,

  //  Item
  POST_CREATE_MENU_ITEM: `/api/Item/AddMenuItem`,
  GET_ALL_ITEMS_FOR_GRID: `/api/Item/BO_GetAllItems`,
  GET_ALL_PRODUCTS: `/api/Item/GetAllMenuItems`,
  GET_ALL_ONLY_PRODUCTS: `/api/Item/GetAllOnlyMenuItems`,
  POST_UPLOAD_PRODUCT_IMAGE: `/api/Item/UploadMenuItemImage`,
  GET_ITEM_BY_ID: `/api/Item/GetMenuItemByID`,
  PUT_UPDATE_ITEM: `/api/Item/UpdateMenuItem`,
  DELETE_ITEM: `/api/Item/DeleteMenuItem`,
  POST_UPDATE_ITEM_SORT_ORDER: `/api/Item/UpdateMenuItemSortOrder`,
  POST_UPDATE_ITEM_STATUS: `/api/Item/UpdateMenuItemStatus`,
  GET_ALL_SHORTED_PRODUCTS: `/api/Item/GetMenuItemsWithShortDetail`,
  PUT_BULK_UPDATE_ITEMS : `/api/Item/BulkUpdateMenuItems`,
  POST_BULK_GET_ITEMS : `/api/Item/BulkGetMenuItemsByIds`,

  // Modifiers
  GET_SEARCH_MODIFIERS: `/api/Modifier/BO_SearchModifier`,

  // Modifier Group

  POST_ADD_MODIFIER_GROUP: `/api/ModifierGroup/AddModifierGroup`,
  GET_ALL_MODIFIER_GROUPS: `/api/ModifierGroup/BO_GetAllModifierGroups`,
  DELETE_MODIFIER_GROUP: `/api/ModifierGroup/DeleteModifierGroup`,
  POST_CHANGE_SKIP_ABLE: `/api/ModifierGroup/ChangeModifierSKipAble`,
  GET_MODIFIER_GROUP_BY_ID: `/api/ModifierGroup/GetModifierGroupByID`,
  PUT_UPDATE_MODIFIER_GROUP: `/api/ModifierGroup/UpdateModifierGroup`,
  POST_ASSIGN_ITEMS_TO_MODIFIER_GROUP: `/api/ItemModifierGroups/AssignItemsToModifierGroup`,
  POST_BULK_ASSIGN_ITEMS_TO_MODIFIER_GROUPS: `/api/ItemModifierGroups/BulkAssignItemsToModifierGroups`,

  //Discount
  GET_ALL_DISCOUNTS: `/api/Discount/BO_GetCompanyDiscountEntry`,
  GET_DISCOUNT_BY_ID: `/api/Discount/GetDiscountByID`,
  POST_ADD_DISCOUNT: `/api/Discount/InsertDiscountEntry`,
  PUT_UPDATE_DISCOUNT: `/api/Discount/UpdateDiscountEntry`,
  DELETE_DISCOUNT: `/api/Discount/DeleteDiscountEntry`,

  //Orders
  GET_ALL_ORDERS: `/api/RecvOrder/BO_GetOrders`,
  DELETE_ORDER: `/api/RecvOrder/DeleteRecvOrder`,
  ARCHIEVE_ORDER: `/api/RecvOrder/ArchieveRecvOrder`,
  GET_ORDER_BY_INVOICE_NO: `/api/RecvOrder/GetOrderByInvoiceNo`,

  //Service Time
  GET_ALL_SERVICE_TIME: `/api/ServiceTime/GetAllServiceTimes`,
  GET_SERVICE_TIME_BY_ID: `/api/ServiceTime/GetServiceTimeforID`,
  POST_ADD_SERVICE_TIME: `/api/ServiceTime/AddServiceTime`,
  PUT_UPDATE_SERVICE_TIME: `/api/ServiceTime/UpdateServiceTime`,
  DELETE_SERVICE_TIME: `/api/ServiceTime/DeleteServiceTime`,

  //Service Time Details
  GET_SERVICE_TIME_DETAILS: `/api/ServiceTimeDetail/GetServiceTimeDetailList`,
  GET_SERVICE_TIME_DETAIL_BY_ID: `/api/ServiceTimeDetail/GetAllServiceTimeDetailsByCompany`,
  POST_ADD_SERVICE_TIME_DETAIL: `/api/ServiceTimeDetail/AddServiceTimeDetail`,

  // Customers
  GET_ALL_CUSTOMERS: `/api/Customer/BO_GetCustomerList`,
  GET_ALL_CUSTOMERS_GROUP_TYPE_LIST: `/api/CustomerTypeGroup/GetAllCustomerTypeGroups`,
  GET_CUSTOMERS_GROUP: `/api/CustomerTypeGroup/BO_GetCustomerTypeGroupList`,
  POST_ADD_UPDATE_CUSTOMER_GROUP: `/api/CustomerTypeGroup/AddUpdateCustomerGroup`,
  DELETE_CUSTOMER_GROUP_TYPE: `/api/CustomerTypeGroup/DeleteCustomerGroup`,
  POST_ADD_UPDATE_CUSTOMER: `/api/Customer/AddUpdateCustomer`,
  GET_CUSTOMER_BY_ID: `/api/Customer/GetCustomerByID`,
  // PUT_UPDATE_CUSTOMER: `/api/Customer/UpdateCustomer`,
  PATCH_UPDATE_CUSTOMER_EMAIL_ADDRESS: `/api/Customer/UpdateCustomerEmailAddress`,
  DELETE_CUSTOMER_BY_ID: `/api/Customer/DeleteCustomerByID`,

  // Receipt Info
  GET_RECEIPT_INFO: `/api/Receipt/GetReceiptInfo`,
  POST_UPDATE_RECEIPT_INFO: `/api/Receipt/UpdateReceiptInfo`,

  // Currency
  GET_ALL_CURRENCIES: `/api/Shared/GetAllCurrencies`,
  GET_ALL_TIMEZONE: `/api/Shared/GetAllTimeZones`,

  // Voucher
  GET_ALL_VOUCHERS: `/api/Voucher/BO_GetCompanyVouchers`,
  GET_VOUCHER_BY_ID: `/api/Voucher/GetVoucherByID`,
  POST_ADD_VOUCHER: `/api/Voucher/InsertVoucher`,
  PUT_UPDATE_VOUCHER: `/api/Voucher/UpdateVoucher`,
  DELETE_VOUCHER: `/api/Voucher/DeleteVoucher`,

  // Reports
  GET_TODAY_SALE: `/api/Report/GetTodaySale`,
  GET_SALES_BREAKDOWN_BY_TIME: `/api/SaleReport/GetSalesBreakdownByTime`,
  GET_SALES_BREAKDOWN_SUMMARY: `/api/SaleReport/GetSalesBreakdownSummary`,
  GET_SALES_BREAKDOWN_BY_PRODUCT: `/api/SaleReport/GetSalesBreakdownByProduct`,
  GET_SALES_BREAKDOWN_BY_PRODUCT_SUMMARY: `/api/SaleReport/GetSalesBreakdownByProductSummary`,
  GET_COMPANY_LOCATIONS: `/api/Company/GetCompanyLocations`,
  GET_TABLE_SPENT_REPORT: `/api/TableReport/GetTableSpent`,
  GET_SERVICE_AREAS: `/api/ServiceArea/GetAllServiceAreas`,

  // Global Search
  GLOBAL_SEARCH: `/api/Search/GlobalSearch`,

  // Online Ordering APIs (Public - No Auth Required)
  GET_RESTAURANT_BY_SLUG: (restaurantSlug, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },
  GET_RESTAURANT_LOCATIONS_BY_SLUG: (restaurantSlug) => `/api/online-ordering/restaurant/${restaurantSlug}/locations`,
  GET_ONLINE_ORDERING_COUNTRIES: () => `/api/online-ordering/countries`,
  CHECK_RESTAURANT_AVAILABILITY: (restaurantSlug, orderType, locationId = null) => {
    const params = new URLSearchParams();
    params.append('orderType', orderType);
    if (locationId) {
      params.append('locationId', locationId);
    }
    return `/api/online-ordering/restaurant/${restaurantSlug}/check-availability?${params.toString()}`;
  },
  VALIDATE_VOUCHER: (restaurantSlug, voucherCode, orderTotal = null, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/voucher/${voucherCode}`;
    const params = new URLSearchParams();
    if (orderTotal != null && orderTotal !== "") params.set("orderTotal", String(orderTotal));
    if (locationId != null && locationId !== "") params.set("locationId", String(locationId));
    const qs = params.toString();
    return qs ? `${baseUrl}?${qs}` : baseUrl;
  },
  VALIDATE_ORDER_COUNT_DISCOUNT: (restaurantSlug, { orderTotal = null, locationId = null, phone = null, customerGuid = null } = {}) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/order-count-discount`;
    const params = new URLSearchParams();
    if (orderTotal != null && orderTotal !== "") params.set("orderTotal", String(orderTotal));
    if (locationId != null && locationId !== "") params.set("locationId", String(locationId));
    if (phone) params.set("phone", String(phone).trim());
    if (customerGuid) params.set("customerGuid", String(customerGuid).trim());
    const qs = params.toString();
    return qs ? `${baseUrl}?${qs}` : baseUrl;
  },
  GET_ONLINE_ORDERING_BANNERS: (restaurantSlug, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/banners`;
    if (locationId !== null && locationId !== undefined && locationId !== "" && Number(locationId) > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },
  GET_ONLINE_ORDERING_PROMOS: (restaurantSlug, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/promos`;
    if (locationId !== null && locationId !== undefined && locationId !== "" && Number(locationId) > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },
  GET_COMPANY_SETTINGS_BY_SLUG: (restaurantSlug) => `/api/online-ordering/restaurant/${restaurantSlug}/settings`,
  // Postcode-based delivery charge resolver (anonymous endpoint)
  QUOTE_DELIVERY_CHARGE: (compId, postalCode) =>
    `/api/DeliveryCharge/Quote?CompID=${encodeURIComponent(compId)}&PostalCode=${encodeURIComponent(postalCode || "")}`,
  GET_MENU_BY_SLUG: (restaurantSlug, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/menu`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },
  GET_CATEGORIES_BY_SLUG: (restaurantSlug, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/categories`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },
  GET_CATEGORY_ITEMS_BY_SLUG: (restaurantSlug, categoryId, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/category/${categoryId}/items`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },
  GET_CATEGORY_AND_SUBCATEGORY_ITEMS_BY_SLUG: (restaurantSlug, categoryId, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/category/${categoryId}/all-items`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },
  SEARCH_ITEMS_BY_SLUG: (restaurantSlug, query) => `/api/online-ordering/restaurant/${restaurantSlug}/search?query=${encodeURIComponent(query)}`,
  GET_FULL_MENU_BY_SLUG: (restaurantSlug, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/full-menu`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },
  GET_ITEMS_WITH_DETAILS_BY_SLUG: (restaurantSlug, categoryId = null, locationId = null) => {
    let baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/items-with-details`;
    const params = [];
    if (categoryId !== null && categoryId !== undefined && categoryId > 0) {
      params.push(`categoryId=${categoryId}`);
    }
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      params.push(`locationId=${locationId}`);
    }
    if (params.length > 0) {
      return `${baseUrl}?${params.join('&')}`;
    }
    return baseUrl;
  },
  GET_COMBOS_BY_SLUG: (restaurantSlug, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/combos`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },
  GET_COMBO_PRODUCTS: (restaurantSlug, comboId, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/combo/${comboId}/products`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },
  
  // Deal APIs
  GET_DEALS_BY_SLUG: (restaurantSlug, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/deals`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },
  GET_DEAL_DETAILS_BY_SLUG: (restaurantSlug, dealId, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/deal/${dealId}`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },
  GET_DEAL_SLOT_ITEMS_BY_SLUG: (restaurantSlug, dealId, slotId, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/deal/${dealId}/slot/${slotId}/items`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },
  
  GET_SERVICE_AREAS_BY_SLUG: (restaurantSlug, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/service-areas`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },
  
  // Online Order Submission (Public - No Auth Required)
  SUBMIT_ONLINE_ORDER: (restaurantSlug, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/order`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },

  // Server-authoritative price quote for the current cart (Public - No Auth Required)
  GET_ORDER_PRICE_QUOTE: (restaurantSlug, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/price-quote`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },

  GET_PAYMENT_CONFIG: (restaurantSlug, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/payment-config`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },

  PREPARE_CHECKOUT: (restaurantSlug, locationId = null, returnBaseUrl = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/prepare-checkout`;
    const params = new URLSearchParams();
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      params.set("locationId", String(locationId));
    }
    if (returnBaseUrl) {
      params.set("returnBaseUrl", returnBaseUrl);
    }
    const query = params.toString();
    return query ? `${baseUrl}?${query}` : baseUrl;
  },

  GET_CHECKOUT_STATUS: (sessionId) => `/api/online-ordering/checkout-status/${sessionId}`,

  FINALIZE_CHECKOUT: (sessionId) => `/api/online-ordering/checkout-status/${sessionId}/finalize`,

  // Online Ordering Customer (public login/signup; my-orders and order require customer token)
  LOGIN_CUSTOMER: (restaurantSlug, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/customer/login`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },
  SIGNUP_CUSTOMER: (restaurantSlug, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/customer/signup`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },
  REFRESH_CUSTOMER_TOKEN: (restaurantSlug, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/customer/refresh-token`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },
  FORGOT_PASSWORD_CUSTOMER: (restaurantSlug, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/customer/forgot-password`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },
  RESET_PASSWORD_CUSTOMER: (restaurantSlug, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/customer/reset-password`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },
  GET_MY_ORDERS: (restaurantSlug, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/my-orders`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },
  GET_ORDER_BY_INVOICE: (restaurantSlug, invoiceNo, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/order/${encodeURIComponent(invoiceNo)}`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },
  GUEST_TRACK_ORDER: (restaurantSlug, invoiceNo, phone, locationId = null) => {
    const params = new URLSearchParams();
    params.set("invoiceNo", String(invoiceNo || "").trim());
    params.set("phone", String(phone || "").trim());
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      params.set("locationId", String(locationId));
    }
    return `/api/online-ordering/restaurant/${restaurantSlug}/order/guest/track?${params.toString()}`;
  },

  // Customer saved addresses (require customer token)
  GET_CUSTOMER_ADDRESSES: (restaurantSlug, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/customer/addresses`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },
  POST_CUSTOMER_ADDRESS: (restaurantSlug, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/customer/addresses`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },
  PUT_CUSTOMER_ADDRESS: (restaurantSlug, id, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/customer/addresses/${id}`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },
  DELETE_CUSTOMER_ADDRESS: (restaurantSlug, id, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/customer/addresses/${id}`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },
  PATCH_CUSTOMER_ADDRESS_SET_DEFAULT: (restaurantSlug, id, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/customer/addresses/${id}/set-default`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },

  GET_CUSTOMER_NOTIFICATIONS: (restaurantSlug, pageNumber = 1, pageSize = 20, locationId = null) => {
    const params = new URLSearchParams();
    params.append("pageNumber", String(pageNumber));
    params.append("pageSize", String(pageSize));
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      params.append("locationId", String(locationId));
    }
    return `/api/online-ordering/restaurant/${restaurantSlug}/customer/notifications?${params.toString()}`;
  },
  GET_CUSTOMER_NOTIFICATIONS_UNREAD_COUNT: (restaurantSlug, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/customer/notifications/unread-count`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },
  PATCH_CUSTOMER_NOTIFICATION_READ: (restaurantSlug, id, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/customer/notifications/${id}/read`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },
  PATCH_CUSTOMER_NOTIFICATIONS_READ_ALL: (restaurantSlug, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/customer/notifications/read-all`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },

  // Customer loyalty rewards (require customer token; read-only points)
  GET_CUSTOMER_LOYALTY: (restaurantSlug, locationId = null, committedPoints = 0) => {
    const params = new URLSearchParams();
    if (committedPoints > 0) params.set("committedPoints", String(committedPoints));
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      params.set("locationId", String(locationId));
    }
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/customer/loyalty`;
    const qs = params.toString();
    return qs ? `${baseUrl}?${qs}` : baseUrl;
  },
  GET_AVAILABLE_REWARDS: (restaurantSlug, locationId = null, committedPoints = 0) => {
    const params = new URLSearchParams();
    if (committedPoints > 0) params.set("committedPoints", String(committedPoints));
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      params.set("locationId", String(locationId));
    }
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/rewards`;
    const qs = params.toString();
    return qs ? `${baseUrl}?${qs}` : baseUrl;
  },
  VALIDATE_REWARD_REDEMPTION: (restaurantSlug, locationId = null) => {
    const baseUrl = `/api/online-ordering/restaurant/${restaurantSlug}/rewards/validate`;
    if (locationId !== null && locationId !== undefined && locationId > 0) {
      return `${baseUrl}?locationId=${locationId}`;
    }
    return baseUrl;
  },

  // Online Reservation APIs (Public - No Auth Required)
  GET_RESERVATION_RESTAURANT_BY_SLUG: (restaurantSlug) => `/api/online-reservation/restaurant/${restaurantSlug}`,
  GET_RESERVATION_SERVICE_AREAS_BY_SLUG: (restaurantSlug) => `/api/online-reservation/restaurant/${restaurantSlug}/service-areas`,
  GET_RESERVATION_SPECIAL_ITEMS_BY_SLUG: (restaurantSlug) => `/api/online-reservation/restaurant/${restaurantSlug}/special-items`,
  GET_RESERVATION_MENU_PRESETS_BY_SLUG: (restaurantSlug) => `/api/online-reservation/restaurant/${restaurantSlug}/menu-presets`,
  GET_RESERVATION_ALL_SPECIAL_ITEMS_BY_SLUG: (restaurantSlug) => `/api/online-reservation/restaurant/${restaurantSlug}/special-items/all`,
  GET_RESERVATION_ALL_MENU_PRESETS_BY_SLUG: (restaurantSlug) => `/api/online-reservation/restaurant/${restaurantSlug}/menu-presets/all`,
  GET_RESERVATION_AVAILABLE_TIME_SLOTS: (restaurantSlug, reservationDate, partySize, serviceAreaId) => {
    const params = new URLSearchParams();
    params.set("reservationDate", reservationDate);
    params.set("partySize", String(partySize));
    // No longer passing reservationType - backend returns all types together
    if (serviceAreaId !== undefined && serviceAreaId !== null && String(serviceAreaId).trim() !== "") {
      params.set("serviceAreaId", String(serviceAreaId));
    }
    return `/api/online-reservation/restaurant/${restaurantSlug}/available-time-slots?${params.toString()}`;
  },
  CREATE_RESERVATION_BY_SLUG: (restaurantSlug) =>
    `/api/online-reservation/restaurant/${restaurantSlug}/reservation`,
  GET_RESERVATION_BY_UUID: (restaurantSlug, reservationUuid) =>
    `/api/online-reservation/restaurant/${restaurantSlug}/reservation/${reservationUuid}`,
  CANCEL_RESERVATION_BY_UUID: (restaurantSlug, reservationUuid) =>
    `/api/online-reservation/restaurant/${restaurantSlug}/reservation/${reservationUuid}/cancel`,
  GET_RESERVATION_PAYMENT_CONFIG: (restaurantSlug) =>
    `/api/online-reservation/restaurant/${restaurantSlug}/payment-config`,
  PREPARE_RESERVATION_CHECKOUT_FROM_REQUEST: (restaurantSlug, returnBaseUrl = null) => {
    const baseUrl = `/api/online-reservation/restaurant/${restaurantSlug}/reservation/prepare-checkout`;
    if (returnBaseUrl) {
      return `${baseUrl}?returnBaseUrl=${encodeURIComponent(returnBaseUrl)}`;
    }
    return baseUrl;
  },
  PREPARE_RESERVATION_CHECKOUT: (restaurantSlug, reservationUuid, returnBaseUrl = null) => {
    const baseUrl = `/api/online-reservation/restaurant/${restaurantSlug}/reservation/${reservationUuid}/prepare-checkout`;
    if (returnBaseUrl) {
      return `${baseUrl}?returnBaseUrl=${encodeURIComponent(returnBaseUrl)}`;
    }
    return baseUrl;
  },
  GET_RESERVATION_CHECKOUT_STATUS: (sessionId) =>
    `/api/online-reservation/checkout-status/${sessionId}`,
  FINALIZE_RESERVATION_CHECKOUT: (sessionId) =>
    `/api/online-reservation/checkout-status/${sessionId}/finalize`,
};

export default APIs;
